import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import engagedType from "./types/engagedType";
import EngagedActions from "./EngagedActions";
import DisengageForm from "./DisengageForm";
import RemovePslForm from "./RemovePslForm";
import {
  Wrapper,
  Header,
  AgentWrapper,
  AgentDetails,
  Avatar,
  AvatarImage,
  TextDetails,
  Name,
  NameLink,
  Company,
  ActiveSince,
  SubmittedCvs,
  StarRating,
  StarRatingLabel,
  FillRating,
  EmptyRating,
  Stars,
  NoRatings,
  HHScore,
  Score,
} from "./styles/engaged-styles";

import { NewBadge, NewBadgeWrapper } from "./styles/new-badge-styles";

const Engaged = ({
  addToPslOnClick,
  agents,
  closeDisengageModal,
  closeRemoveFromPslModal,
  disengageModalShown,
  disengageOnClick,
  errors,
  formLoading,
  handleDisengageOnSubmit,
  handleRemoveFromPslSubmit,
  recruiterCompanyName,
  removeFromPslModalShown,
  removeFromPslOnClick,
  setDisengagementMessage,
  setRemoveFromPslMessage,
  isPortalEmployer,
}) => {
  const handleCompanyName = (companyName) => {
    if (window.innerWidth > 320) {
      if (companyName.length > 30) {
        return `${companyName.slice(0, 30)}...`;
      }
      return companyName;
    }
    if (companyName.length > 25) {
      return `${companyName.slice(0, 25)}...`;
    }
    return companyName;
  };

  return (
    <Wrapper>
      {disengageModalShown && (
        <DisengageForm
          handleDisengageOnSubmit={handleDisengageOnSubmit}
          setDisengagementMessage={setDisengagementMessage}
          closeDisengageModal={closeDisengageModal}
          formLoading={formLoading}
          errors={errors}
        />
      )}
      {removeFromPslModalShown && (
        <RemovePslForm
          handleRemoveFromPslSubmit={handleRemoveFromPslSubmit}
          setRemoveFromPslMessage={setRemoveFromPslMessage}
          closeRemoveFromPslModal={closeRemoveFromPslModal}
          recruiterCompanyName={recruiterCompanyName}
          formLoading={formLoading}
          errors={errors}
        />
      )}
      <Header>Currently Engaged</Header>
      {agents.map((agent) => (
        <AgentWrapper key={agent.engagementId}>
          <AgentDetails>
            <Avatar>
              <AvatarImage src={agent.avatar} alt="Avatar" />
            </Avatar>
            <TextDetails>
              <Name psl={agent.psl}>
                <NameLink
                  href={agent.agentUrl}
                  title={agent.name}
                  data-turbolinks="false"
                >
                  {agent.name}
                </NameLink>
              </Name>
              <Company> {handleCompanyName(agent.company)} </Company>
              <ActiveSince>Active since: {agent.activeSince}</ActiveSince>
              <HHScore>
                HH Score:{" "}
                {agent.isNew ? (
                  "no score yet"
                ) : (
                  <Score>{agent.hhScore}/10</Score>
                )}
              </HHScore>
              {agent.isNew && (
                <NewBadgeWrapper>
                  <NewBadge>NEW!</NewBadge>
                </NewBadgeWrapper>
              )}
              {agent.starRatingPercent ? (
                <StarRating className="star-ratings">
                  <StarRatingLabel>Reviews:</StarRatingLabel>
                  <FillRating
                    className="fill-ratings"
                    style={{ width: `${agent.starRatingPercent}%` }}
                  >
                    <Stars>★★★★★</Stars>
                  </FillRating>
                  <EmptyRating className="empty-ratings">
                    <Stars>★★★★★</Stars>
                  </EmptyRating>
                </StarRating>
              ) : (
                <NoRatings>no ratings yet</NoRatings>
              )}
            </TextDetails>
          </AgentDetails>
          <SubmittedCvs
            data-tip="CVs submitted for this role"
            data-for="cv-submitted-tooltip"
          >
            {agent.cvsSubmitted} CVs
          </SubmittedCvs>
          <ReactTooltip
            place="top"
            type="dark"
            effect="solid"
            aria-haspopup="true"
            id="cv-submitted-tooltip"
          />
          <EngagedActions
            recruiterId={agent.recruiterId}
            recruiterCompanyName={agent.company}
            engagementId={agent.engagementId}
            psl={agent.psl}
            messageUrl={agent.messageUrl}
            jobId={agent.jobId}
            disengageUrl={agent.disengageUrl}
            disengageOnClick={disengageOnClick}
            addToPslOnClick={addToPslOnClick}
            removeFromPslOnClick={removeFromPslOnClick}
            isPortalEmployer={isPortalEmployer}
          />
        </AgentWrapper>
      ))}
    </Wrapper>
  );
};

Engaged.propTypes = {
  agents: engagedType.isRequired,
  addToPslOnClick: PropTypes.func.isRequired,
  disengageOnClick: PropTypes.func.isRequired,
  disengageModalShown: PropTypes.bool.isRequired,
  setDisengagementMessage: PropTypes.func.isRequired,
  handleDisengageOnSubmit: PropTypes.func.isRequired,
  closeDisengageModal: PropTypes.func.isRequired,
  removeFromPslOnClick: PropTypes.func.isRequired,
  removeFromPslModalShown: PropTypes.bool.isRequired,
  setRemoveFromPslMessage: PropTypes.func.isRequired,
  handleRemoveFromPslSubmit: PropTypes.func.isRequired,
  closeRemoveFromPslModal: PropTypes.func.isRequired,
  recruiterCompanyName: PropTypes.string,
  formLoading: PropTypes.bool.isRequired,
  errors: PropTypes.shape({}).isRequired,
  isPortalEmployer: PropTypes.bool.isRequired,
};

Engaged.defaultProps = {
  recruiterCompanyName: PropTypes.isNull,
};

export default Engaged;
